import {
  Paper,
  Stack,
  Typography,
  Box,
  Switch,
  Chip,
  Grid,
  Alert,
  Button
} from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";
import { useFeatureFlags, FeatureFlagKey } from "../../contexts/FeatureFlagsContext";

export const AdminFeatureFlagsPage = () => {
  const { flags, updateFlag } = useFeatureFlags();

  const handleToggleFeature = (key: FeatureFlagKey, enabled: boolean) => {
    updateFlag(key, { enabled });
  };

  return (
      <Box sx={{ minHeight: '100%' }}>
        <Stack spacing={3}>
          <Box>
            <Typography variant="h4" fontWeight={700} sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
              <FlagIcon sx={{ color: '#d22268' }} />
              Feature Flags
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Enable or disable features for different user types and account levels.
            </Typography>
          </Box>

          {/* Simple list of all flags */}
          {flags && flags.length > 0 && (
            <Box>
              <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
                Available Features ({flags.length})
              </Typography>
              <Grid container spacing={2}>
                {flags.map((feature, index) => (
                  <Grid item xs={12} md={6} key={feature.key || index}>
                    <Paper
                      elevation={1}
                      sx={{
                        p: 3,
                        border: '1px solid #e0e0e0',
                        borderRadius: 2,
                        backgroundColor: feature.enabled ? '#f8f9fa' : '#ffffff'
                      }}
                    >
                      <Stack spacing={2}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Box>
                            <Typography variant="h6" fontWeight={600} sx={{ mb: 0.5 }}>
                              {feature.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {feature.description}
                            </Typography>
                          </Box>
                          <Switch
                            checked={feature.enabled}
                            onChange={(e) => handleToggleFeature(feature.key, e.target.checked)}
                            sx={{
                              '& .MuiSwitch-switchBase.Mui-checked': {
                                color: '#0DAB76',
                              },
                              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: '#0DAB76',
                              },
                            }}
                          />
                        </Stack>

                        <Stack direction="row" spacing={1}>
                          {feature.accountTypes?.map((type: string) => (
                            <Chip
                              key={type}
                              label={type}
                              size="small"
                              variant="outlined"
                              sx={{
                                fontSize: '0.75rem',
                                height: 24,
                                borderColor: type === 'Designer' ? '#d22268' : type === 'Homeowner' ? '#1976d2' : '#666',
                                color: type === 'Designer' ? '#d22268' : type === 'Homeowner' ? '#1976d2' : '#666'
                              }}
                            />
                          ))}
                        </Stack>
                      </Stack>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          {/* Fallback if no flags */}
          {(!flags || flags.length === 0) && (
            <Alert severity="warning">
              <Typography variant="body2">
                No feature flags available.
              </Typography>
            </Alert>
          )}
        </Stack>
      </Box>
    );
};

export default AdminFeatureFlagsPage;